import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import ConfirmationButton from 'components/shared/ConfirmationButton';
import DialogTemplate from 'components/shared/DialogTemplate';
import {
  Button,
  Divider,
  Typography,
  makeStyles,
} from '@material-ui/core';

const styles = makeStyles((theme) => ({
  root: {
    paddingTop: theme.spacing(4),
    textAlign: 'center',
  },
  divider: {
    marginBottom: theme.spacing(4),
  },
  button: {
    marginTop: theme.spacing(4),
    marginBottom: theme.spacing(4),
  },
  red: {
    color: theme.palette.error.A400,
  },
}));

const HideRemove = ({
  disabled,
  onlyRemove,
  onClose,
  onHide,
  onRemove,
}) => {
  const classes = styles();

  return (
    <DialogTemplate
      title={onlyRemove ? (
        <FormattedMessage
          id="cottages.remove"
          defaultMessage="Remove ad"
        />
      ) : (
        <FormattedMessage
          id="cottages.hideRemove"
          defaultMessage="Hide / remove ad"
        />
      )}
      onClose={onClose}
    >
      <div className={classes.root}>
        {!onlyRemove && (
          <>
            <Typography>
              <FormattedMessage
                id="cottages.toHide"
                defaultMessage="To hide your ad from visitors, click the button below"
              />
            </Typography>
            <Button
              variant="contained"
              onClick={onHide}
              disabled={disabled}
              className={classes.button}
            >
              <FormattedMessage
                id="Hide ad"
                defaultMessage="Hide ad"
              />
            </Button>
            <Divider className={classes.divider} />
          </>
        )}
        <Typography>
          <FormattedMessage
            id="cottages.toRemove"
            defaultMessage="To {remove} your ad {permanently}, click the button below"
            values={{
              remove: (
                <span className={classes.red}>
                  <FormattedMessage
                    id="remove"
                    defaultMessage="remove"
                  />
                </span>
              ),
              permanently: (
                <span className={classes.red}>
                  <FormattedMessage
                    id="permanently"
                    defaultMessage="permanently"
                  />
                </span>
              ),
            }}
          />
        </Typography>
        <ConfirmationButton
          variant="contained"
          color="secondary"
          disabled={disabled}
          dialogText={(
            <FormattedMessage
              id="cottages.deleteConfirmation"
              defaultMessage="Are you sure you want to delete your ad? This cannot be undone."
            />
          )}
          onConfirm={onRemove}
          className={classes.button}
        >
          <FormattedMessage
            id="Remove ad"
            defaultMessage="Remove ad"
          />
        </ConfirmationButton>
      </div>
    </DialogTemplate>
  );
};

HideRemove.propTypes = {
  disabled: PropTypes.bool,
  onlyRemove: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  onHide: PropTypes.func.isRequired,
  onRemove: PropTypes.func,
};

export default HideRemove;
